import React from 'react';
import { useFetchDashboard } from '../../../hooks/admin/dashboard/dashboard';

const Dashboard: React.FC = () => {
  const dashboardAPI= useFetchDashboard()
  return (
    <div className="bg-gray-100 min-h-screen flex flex-col font-sans">

      {/* Sidebar */}
   

      {/* Main Content */}
      <div className="flex-1 p-6">
        <div className="flex justify-between items-center mb-4">
          <div>
            <h1 className="text-3xl font-bold text-gray-800">Dashboard Overview</h1>
            <p className="text-gray-500">Welcome back, Admin</p>
          </div>
          <div>
            {/* User Avatar or Icon */}
            <div className="bg-gray-300 rounded-full h-10 w-10"></div> {/* Replace with your avatar */}
          </div>
        </div>

        {/* Metrics Section */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
          <div className="bg-white shadow rounded p-4">
            <div className="flex items-center justify-between">
              <span className="text-gray-600">Total Users</span>
              {/* Add icon here if needed */}
            </div>
            <h3 className="text-2xl font-bold text-gray-800">24,892</h3>
            <p className="text-green-500 mt-1 prose ">+12% this week</p>
          </div>
          {/* Repeat similar structure for Cache Hit Rate, Accuracy Score, Response Time */}
          <div className="bg-white shadow rounded p-4">
            <div className="flex items-center justify-between">
              <span className="text-gray-600">Cache Hit Rate</span>
              {/* Add icon here if needed */}
            </div>
            <h3 className="text-2xl font-bold text-gray-800">87.5%</h3>
            <p className="text-green-500 mt-1">+3.2% this week</p>
          </div>
          <div className="bg-white shadow rounded p-4">
            <div className="flex items-center justify-between">
              <span className="text-gray-600">Accuracy Score</span>
              {/* Add icon here if needed */}
            </div>
            <h3 className="text-2xl font-bold text-gray-800">94.2%</h3>
            <p className="text-green-500 mt-1">-1.5% this week</p>
          </div>
          <div className="bg-white shadow rounded p-4">
            <div className="flex items-center justify-between">
              <span className="text-gray-600">Response Time</span>
              {/* Add icon here if needed */}
            </div>
            <h3 className="text-2xl font-bold text-gray-800">1.2s</h3>
            <p className="text-green-500 mt-1">+15% faster</p>
          </div>
        </div>

        {/* Recent Alerts Section */}
        <div className="bg-white shadow rounded p-6">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-bold text-gray-800">Recent Alerts</h2>
            <span className="text-blue-500 cursor-pointer">View All</span>
          </div>
          {/* Alert Items */}
          <div className="mb-3 flex items-start bg-red-200 p-2 rounded-md"> {/* Use items-start for vertical alignment */}
            <div className="text-red-500  mr-2">&#9888;</div> {/* Replace with your icon */}
            <div>
              <p className="text-gray-800 font-medium">High Error Rate Detected</p>
              <p className="text-gray-500 text-sm">Technical documentation responses showing 15% error rate</p>
              <p className="text-gray-500 text-sm">2h ago</p>
            </div>
          </div>
          {/* Repeat similar structure for other alerts */}
           <div className="mb-3 flex items-start bg-yellow-200 p-2 rounded-md" > {/* Use items-start for vertical alignment */}
            <div className="text-yellow-500 mr-2">&#9888;</div> {/* Replace with your icon */}
            <div>
              <p className="text-gray-800 font-medium">Cache Update Required</p>
              <p className="text-gray-500 text-sm">HR policy documents have been updated</p>
              <p className="text-gray-500 text-sm">5h ago</p>
            </div>
          </div>
           <div className="mb-3 flex items-start bg-green-200 p-2 rounded-md"> {/* Use items-start for vertical alignment */}
            <div className="text-green-500 mr-2">&#10004;</div> {/* Replace with your icon */}
            <div>
              <p className="text-gray-800 font-medium">System Performance Improved</p>
              <p className="text-gray-500 text-sm">Response time reduced by 25%</p>
              <p className="text-gray-500 text-sm">1d ago</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;